<template>
  <v-container style="padding-top:0px !important" grid-list-xs px-4>
   <!--  {{ errors }} -->
    <v-layout row wrap>
      <v-flex xs12>
        <!-- todos-->
        <v-text-field
          readonly
          v-model="newUser.profile.identity"
          name="identification"
          v-bind:label="$t('message.identification')"
          v-validate="'required'"
          :error-messages="errors.collect('identification')"
        ></v-text-field>
      </v-flex>
      <v-flex xs12>
        <v-text-field
        v-model="newUser.profile.aps"
        name="aps"
        v-bind:label="$t('message.aps')"
        v-validate="'required'"
        :error-messages="errors.collect('aps')">
        </v-text-field>
      </v-flex>
      <v-text-field
        v-model="newUser.profile.institute_code"
        name="insititutionCode"
        v-bind:label="$t('message.insititutionCode')"
      ></v-text-field>
      <v-flex xs12>
        <v-select
          :items="personType"
          item-text="text"
          item-value="value"
          v-model="newUser.profile.person_type"
          name="personType"
          v-bind:label="$t('message.personType')"
          v-validate="'required'"
          :error-messages="errors.collect('personType')"
          :disabled="typePersonEdit"
          readonly
        ></v-select>
        <v-text-field
          v-model="newUser.profile.business_name"
          v-show="showNaturalJurid"
          :counter="50"
          :maxlength="50"
          name="socialReason"
          v-bind:label="$t('message.socialReason')"
          v-validate="!showNaturalJurid ? '' : 'required'"
          :error-messages="errors.collect('socialReason')"
        ></v-text-field>
        <v-text-field
          v-show="showNaturalJurid"
          v-model="newUser.profile.trademark"
          :counter="50"
          :maxlength="50"
          name="trademark"
          v-bind:label="$t('message.trademark')"
          v-validate="!showNaturalJurid ? '' : 'required'"
          :error-messages="errors.collect('trademark')"
        ></v-text-field>
        <v-text-field
          v-show="showNaturalJurid"
          v-model="newUser.profile.legal_representative"
          :counter="50"
          :maxlength="50"
          name="legalRepresentative"
          v-bind:label="$t('message.legalRepresentative')"
          v-validate="!showNaturalJurid ? '' : 'required'"
          :error-messages="errors.collect('legalRepresentative')"
        ></v-text-field>
        <v-text-field
          v-show="!showNaturalJurid"
          v-model="newUser.profile.first_name"
          :counter="50"
          :maxlength="50"
          name="firstName"
          v-bind:label="$t('message.firstName')"
          v-validate="showNaturalJurid ? '' : 'required'"
          :error-messages="errors.collect('firstName')"
        ></v-text-field>
        <v-text-field
          v-if="!showNaturalJurid"
          v-model="newUser.profile.second_name"
          :counter="50"
          :maxlength="50"
          name="secondName"
          v-bind:label="$t('message.secondName')"
        ></v-text-field>
        <v-text-field
          v-show="!showNaturalJurid"
          v-model="newUser.profile.first_surname"
          :counter="50"
          :maxlength="50"
          name="firstSurname"
          v-bind:label="$t('message.firstSurname')"
          v-validate="showNaturalJurid ? '' : 'required'"
          :error-messages="errors.collect('firstSurname')"
        ></v-text-field>
        <v-text-field
          v-show="!showNaturalJurid"
          v-model="newUser.profile.second_surname"
          :counter="50"
          :maxlength="50"
          name="secondSurname"
          v-bind:label="$t('message.secondSurname')"
          v-validate="showNaturalJurid ? '' : 'required'"
          :error-messages="errors.collect('secondSurname')"
        ></v-text-field>
        <!-- tipo aps -->
      </v-flex>
      <!--               <v-flex xs12>
                <v-text-field label="Primer Nombre" id="id"></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field label="Segundo Nombre" id="id"></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field label="Primer Apellido" id="id"></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field label="Segundo Apellido" id="id"></v-text-field>
      </v-flex>-->
      <v-flex xs12 v-show="!showNaturalJurid">
        <!-- natural, -->
        <v-menu
          ref="menu"
          :close-on-content-click="false"
          v-model="menu"
          :nudge-right="40"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
        >
          <v-text-field
            slot="activator"
            v-model="newUser.profile.birth_date"
            append-icon="event"
            name="birthDate"
            v-bind:label="$t('message.birthDate')"
          ></v-text-field>
          <v-date-picker
            ref="picker"
            v-model="newUser.profile.birth_date"
            min="1950-01-01"
            @change="saveDate"
            locale="es-419"
          ></v-date-picker>
        </v-menu>
      </v-flex>
      <v-flex xs12>
        <!-- todos -->
        <v-autocomplete
          :items="catalogsNacionalities"
          v-model="newUser.profile.nationality"
          item-text="value"
          item-value="value"
          name="nationality"
          v-bind:label="$t('message.nationality')"
        ></v-autocomplete>
      </v-flex>
      <!-- Gender y civil state natural implementar -->
      <v-flex xs12>
        <v-select
          :items="catalogsGender"
          v-model="newUser.profile.gender"
          item-text="value"
          item-value="value"
          name="gender"
          v-bind:label="$t('message.gender')"
        ></v-select>
      </v-flex>
      <v-flex xs12 v-show="!showNaturalJurid">
        <v-select
          :items="catalogsCivilStatus"
          v-model="newUser.profile.civil_status"
          item-text="value"
          item-value="value"
          name="civilStatus"
          v-bind:label="$t('message.civilStatus')"
        ></v-select>
      </v-flex>
      <v-flex xs12>
        <!-- todos -->
        <v-text-field
          v-model="newUser.profile.country"
          name="country"
          v-bind:label="$t('message.country')"
          v-validate="'required'"
          :error-messages="errors.collect('country')"
        ></v-text-field>
      </v-flex>
      <v-flex xs12>
        <!-- todos -->
        <v-autocomplete
          item-text="value"
          item-value="value"
          :items="catalogsProvince"
          v-model="newUser.profile.province"
          @change="changeApplicantProvince(newUser.profile.province.code)"
          name="province"
          v-bind:label="$t('message.province')"
          :error-messages="errors.collect('province')"
          return-object
        >></v-autocomplete>
      </v-flex>
      <v-flex xs12>
        <!-- todos -->
        <v-select
          :items="applicantCatalogsCantonByProvince"
          v-model="newUser.profile.city"
          item-text="value"
          item-value="value"
          name="onlyCity"
          v-bind:label="$t('message.onlyCity')"
          :error-messages="errors.collect('onlyCity')"
        ></v-select>
      </v-flex>
      <v-flex xs12>
        <!-- todos -->
        <v-text-field
          v-model="newUser.profile.parish"
          name="parish"
          v-bind:label="$t('message.parish')"
        ></v-text-field>
      </v-flex>
      <v-flex xs12>
        <!-- todos -->
        <v-text-field
          v-model="newUser.profile.home_address"
          name="homeAddress"
          v-bind:label="$t('message.homeAddress')"
          :error-messages="errors.collect('homeAddress')"
        ></v-text-field>
        <!-- tipo aps -->
        <!-- todos -->
        <v-text-field
          v-model="newUser.email"
          name="emailRegister"
          v-bind:label="$t('message.emailRegister')"
          v-validate="'required|email'"
          :error-messages="errors.collect('emailRegister')"
          readonly
        ></v-text-field>
        <!-- todos -->
        <v-text-field
          v-model="newUser.profile.notification_email"
          name="emailNotification"
          v-bind:label="$t('message.emailNotification')"
          v-validate="'email'"
          :error-messages="errors.collect('emailNotification')"
        ></v-text-field>
        <!-- todos -->
        <v-text-field
          v-model="newUser.profile.billing_email"
          name="emailBilling"
          v-bind:label="$t('message.emailBilling')"
          v-validate="'email'"
          :error-messages="errors.collect('emailBilling')"
        ></v-text-field>
        <!-- todos requerido solo aps juridico -->
        <!-- todos -->
         <v-text-field
          name='emailOffice'
          v-model="newUser.profile.office_email"
          v-bind:label="$t('message.emailOffice')"
        ></v-text-field>
        <v-text-field
          v-model="newUser.profile.personal_email"
          name="personalEmail"
          v-bind:label="$t('message.personalEmail')"
          v-validate="'email'"
          :error-messages="errors.collect('personalEmail')"
        ></v-text-field>
        <!-- todos -->
        <v-text-field
          v-model="newUser.profile.cell_phone"
          v-bind:label="$t('message.mobilePhone')"
          :counter="10"
          :maxlength="10"
          name="mobilePhone"
          v-validate="'digits:10|start:09'"
          :error-messages="errors.collect('mobilePhone')"
           mask="(###) ###-####"
        ></v-text-field>
        <!-- tipo aps -->
        <!-- implementar telefono domicilio tipo ejecutivo -->
        <v-text-field
          v-if="newUser.profile.type=='aps_executive'"
          v-model="newUser.profile.home_phone"
          v-bind:label="$t('message.homePhone')"
          name="homePhone"
          :counter="10"
          :maxlength="10"
          v-validate="'digits:9|start:0'"
          :error-messages="errors.collect('homePhone')"
          mask="(##) ####-###"
        ></v-text-field>
        <!-- todos -->
        <v-text-field
          v-model="newUser.profile.web_page"
          name="webPage"
          v-bind:label="$t('message.webPage')"
        ></v-text-field>
        <!-- todos -->
        <v-text-field
          v-model="newUser.profile.postal_code"
          name="postalCode"
          v-bind:label="$t('message.postalCode')"
        ></v-text-field>
        <!-- implementar fecha acreditacion tipo aps juridico y natural -->
        <!-- tipo aps juridico natural -->
      </v-flex>
      <!-- aps -->
      <!-- aps natural y juridico -->
      <!-- ejecutivo -->
      <!-- aps -->
      <!-- tipo aps -->
    </v-layout>
<!--     <v-card-actions>
      <v-spacer></v-spacer>
      <v-flex xs4>
        <v-layout row wrap>
          <v-flex xs5>
            <v-btn @click="dialog = false " color="default">Cancelar</v-btn>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs5>
            <v-btn color="accent" @click="createUser()">Guardar</v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-card-actions> -->
    
     <v-layout row justify-center>
      <v-dialog v-model="dialog" v-if="dialog" persistent max-width="600px">
        <v-card>
          
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field 
                  name="password"
                  v-model="dialogPassword"
                  v-bind:label="$t('message.password')"
                  v-validate="'required'"
                  :error-messages="errors.collect('password')"  type="password" ></v-text-field>
                </v-flex>
              </v-layout>
              
        <v-layout style="" row wrap>
          <v-flex xs5>
            <v-btn @click="dialog = false" color="default">Cancelar</v-btn>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs5>
            <v-btn :disabled="disableConfirm" color="accent" @click="createUser()">Confirmar</v-btn>
          </v-flex>
        </v-layout>
            </v-container>
          
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>
<script>
/* import gm from "gm"; */
import CatalogServices from "@/services/CatalogsServices";
import { mapGetters } from "vuex";
import { EventBus } from "@/imports/EventBus";
import accountServices from '@/services/AccountsServices'
import AppConfig from '@/config/AppConfig'
import { setTimeout } from 'timers';
import AvatarServices from "@/services/AvatarServices";

export default {
  data() {
    return {
      disableConfirm:true,
      dialog:false,
      showNaturalJurid: false,
      valid: false,
      typePersonEdit: false,
      applicantCatalogsCantonByProvince: [],
      insuredCatalogsCantonByProvince: [],
      cities: [],
      parishes: [],
      menu: false,
      menu1: false,
      menu2: false,
      dialog: false,
      typeUser: [
        { text: "APS", value: "aps_broker" },
        { text: "EJECUTIVO", value: "aps_executive" },
        { text: "ADMIN", value: "aps_admin" },
        { text: "PROMOTOR", value: "aps_promotor" }
      ],
      personType: [
        { text: "JURIDICO", value: "JURIDICO" },
        { text: "NATURAL", value: "NATURAL" }
      ],
      dialogPassword:undefined,
       newUser: {
        email: undefined,
        password: undefined,
        profile: {
          user_id: undefined,
          institute_code:undefined,
          type: "aps_executive",
          identity: undefined,
          identity_type: "RUC",
          agencies: [],
          id_aps_sos: undefined,
          person_type: "NATURAL",
          first_name: undefined,
          second_name: undefined,
          first_surname: undefined,
          second_surname: undefined,
          business_name: undefined,
          birth_date: undefined,
          accreditation_date: undefined,
          nationality: undefined,
          gender: null,
          civil_status: undefined,
          country: "ECUADOR",
          canton: undefined,
          city: undefined,
          province: undefined,
          parish: undefined,
          home_address: undefined,
          email: undefined,
          personal_email: undefined,
          home_phone: undefined,
          cell_phone: undefined,
          office_phone: undefined,
          aps: undefined,
          office_address: undefined,
          notification_email: undefined,
          legal_representative: undefined,
          billing_email: undefined,
          office_email: undefined,
          creation_date: undefined,
          user_name: undefined,
          executives: [],
          id_aps_vt: undefined,
          web_page: undefined,
          postal_code: undefined
        }
      },
      rules: {
        required: value => !!value || "Campo Requerido",
        requiredS: value => value.length > 0 || "Campo Requerido",
        counter: value => value.length >= 2 || "Mínimo 2 caracteres",
        identification: value =>
          value.length == 10 || "Diez dígitos obligatorios",
        phoneNumber: value => value.length >= 10 || "Mínimo 10 digitos",
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Dirección email invalida";
        }
      }
    };
  },
  beforeDestroy() {
    EventBus.$off("searchExternalAgent");
    EventBus.$off("openForm");
  },
  mounted() {
    EventBus.$on("searchExternalAgent", data => {
      this.newUser = data;
    });
    EventBus.$on("openForm", data => {
      this.errors.clear(); 
      this.dialogPassword=undefined;
      this.newUser = {
        email: undefined,
        password: undefined,
        profile: {
          user_id: undefined,
          institute_code:undefined,
          type: "aps_executive",
          identity: undefined,
          identity_type: "RUC",
          agencies: [],
          id_aps_sos: undefined,
          person_type: "NATURAL",
          first_name: undefined,
          second_name: undefined,
          first_surname: undefined,
          second_surname: undefined,
          business_name: undefined,
          birth_date: undefined,
          accreditation_date: undefined,
          nationality: undefined,
          gender: null,
          civil_status: undefined,
          country: "ECUADOR",
          canton: undefined,
          city: undefined,
          province: undefined,
          parish: undefined,
          home_address: undefined,
          email: undefined,
          personal_email: undefined,
          home_phone: undefined,
          cell_phone: undefined,
          office_phone: undefined,
          aps: undefined,
          office_address: undefined,
          notification_email: undefined,
          legal_representative: undefined,
          billing_email: undefined,
          office_email: undefined,
          creation_date: undefined,
          user_name: undefined,
          executives: [],
          id_aps_vt: undefined,
          web_page: undefined,
          postal_code: undefined
        }
      }
    });
  },
  watch: {
    "newUser.profile.person_type"(val) {
      if (this.newUser.profile.person_type == "NATURAL") {
        this.showNaturalJurid = false;
      } else if (this.newUser.profile.person_type == "JURIDICO") {
        this.showNaturalJurid = true;
      }
    },
    "newUser.email"(val) {
      this.newUser.profile.email=val
    },
    "dialogPassword"(val) {
      if(val!=''){
        this.disableConfirm=false
      }else{
        
        this.disableConfirm=true
      }
    }
  },
  computed: {
    ...mapGetters([
      "catalogsProvince",
      "catalogsCanton",
      "catalogsCity",
      "catalogsCivilStatus",
      "catalogsGender",
      "catalogsNacionalities"
    ])
  },
  methods: {
    changeProvince() {
      let resultSearch = this.catalogsProvince.find(
        obj => obj.code == this.newUser.profile.province
      );
      this.$store.dispatch("getCatalogsCanton", resultSearch.provinceCode);
      this.$store.dispatch(
        "getCatalogsCityByProvince",
        resultSearch.provinceCode
      );
    },
    async changeApplicantProvince(provinceId) {
      
   
        CatalogServices.getCantonByProvince(provinceId)
          .then(response => {


            this.applicantCatalogsCantonByProvince = response.data.data;
          })
          .catch(res => {
            this.$root.$emit("showSnackBar", "Error desconocido", "error");
            this.applicantCatalogsCantonByProvince = [];
          });
      
    },
    searchExternalAgent() {
      if (
        this.newUser.profile.user_id != "" &&
        this.newUser.profile.user_id != undefined
      ) {
        this.$root.$emit("showLoading", "Consultando");
        this.$store
          .dispatch("searchExternalAgent", this.newUser.profile.user_id)
          .then(res => {
            if (res.data.error == 100) {
              this.$root.$emit(
                "showSnackBar",
                "No existen datos para el id ingresado",
                "error"
              );
              this.$root.$emit("hideLoading");
            } else {
              this.newUser.email = res.data.data.CorreoElectronico;
              if (res.data.data.Identificacion.length > 10) {
                this.newUser.password = res.data.data.Identificacion.substring(
                  0,
                  10
                );
              } else {
                this.newUser.password = res.data.data.Identificacion;
              }
              this.newUser.profile.identity = res.data.data.Identificacion;
              this.newUser.profile.agencies = res.data.data.ListaAgencias;
              this.newUser.profile.business_name = res.data.data.Nombre;
              this.newUser.profile.user_name = res.data.data.NombreUsuario;
              this.newUser.profile.id_aps_vt = res.data.data.IdApsVt;

              this.$root.$emit("hideLoading");
            }
          });
      }
    },
    checkEmail() {
            
            this.$validator.validateAll().then(success => {
               //console.log(this.newUser.profile)
             if(success){
                   accountServices.checkEmailRegister(localStorage.getItem("accessToken"), this.newUser.email).then(result => {
                
           // console.log(result)
                switch (result.data.code) {
                    case 401:
                     this.$root.$emit(
                      "showSnackBar",
                      "El usuario ya existe en otra aplicación, por favor ingrese la contraseña de la cuenta: "+this.newUser.email+", para poder continuar.",
                      "accent"
                    );
                      setTimeout(() => {
                        
                      this.dialog=true;
                      }, 200);
                      break;

                    case 200:
                        this.$root.$emit(
                          "showSnackBar",
                          "Ya existe un usuario registrado con el email: "+this.newUser.email,
                          "error"
                        );
                       
                        break;
                    default:
                        this.createUser();
                        break;
                }
            });
              }
           });
      },
     createUser() {
      this.$validator.validateAll().then(success => {
        if (success) {
                  this.disableConfirm=true
           let params;
             if(this.newUser.profile.person_type=="NATURAL"){
               params={name:this.newUser.profile.first_name,lastName:this.newUser.profile.first_surname}
             }else{
               params={name:this.newUser.profile.business_name,lastName:""}
             }
              AvatarServices.createAvatar(params).then((res)=>{
              if(res.data.error===0){
                this.newUser.profile.photoUrl=res.data.data
                   if (this.dialog) {
            this.newUser.password = this.dialogPassword;
            accountServices
              .createLoginTokenPortalWeb(
                this.newUser.email,
                this.newUser.password
              )
              .then(res => {
                //console.log("login", res.data);
               if (res.data.code == 401 && res.data.msg=="Invalid credentials") {
                  this.$root.$emit(
                    "showSnackBar",
                    "La contraseña es incorrecta",
                    "error"
                  );
                  this.$root.$emit("hideLoading");
                }else if(res.data.code == 401 && res.data.msg=="User not registered into application"){
                  accountServices.createLoginTokenCSC( this.newUser.email,this.newUser.password).then(
                    (res)=>{
                      if (res.data.code == 401) {
                        this.$root.$emit(
                          "showSnackBar",
                          "La contraseña es incorrecta",
                          "error"
                        );
                        this.$root.$emit("hideLoading");
                      }else if(res.data.code == 200){

                         this.$store.dispatch("registerUser", this.newUser).then(res => {
                          if (res.data.code == 400) {
                            this.$root.$emit(
                              "showSnackBar",
                              "Este usuario ya se ha registrado",
                              "error"
                            );
                            this.dialog = false;
                            this.$root.$emit("hideLoading");
                          } else if (res.data.code == 401) {
                            this.$root.$emit(
                              "showSnackBar",
                              "La contraseña es incorrecta",
                              "error"
                            );
                            this.$root.$emit("hideLoading");
                          } else {
                                  let scopes = {
                                      userId: res.data.data.userId,
                                      scope: "aps_user aps_executive"
                                    };
                                  accountServices
                                            .updateScopesAccountIAM(scopes)
                                            .then(result => {
            this.$root.$emit("showSnackBar", "Registro Exitoso");
                                this.dialog = false;
                                EventBus.$emit("closeDialog");
                                this.$root.$emit("hideLoading");

                                            });


                    
                              
                          }
                        });
                        
                              this.disableConfirm=false
                      }
                    }
                  )
                } else if (res.data.code == 200) {
                  this.$store
                    .dispatch("registerUser", this.newUser)
                    .then(response => {
                      //console.log("APS", response.data);
                      if (response.data.code == 200) {

                           let scopes = {
                                      userId: res.data.data.userId,
                                      scope: "aps_user aps_executive"
                                    };
                                  accountServices
                                            .updateScopesAccountIAM(scopes)
                                            .then(result => {
           accountServices.updateUserAccountIAMPortalWeb(res.data.data.accessToken,{aps_user:"true"}).then(result => {
                            if (result.data.code == 200) {
                              this.$root.$emit(
                                "showSnackBar",
                                "Registro Exitoso"
                              );
                              this.dialog = false;
                              EventBus.$emit("closeDialog");
                              this.$root.$emit("hideLoading");
                            } else {
                              this.$root.$emit(
                                "showSnackBar",
                                "Ha ocurrido un error registrando al ejecutivo en portal web",
                                "error"
                              );
                              this.dialog = false;
                              EventBus.$emit("closeDialog");
                              this.$root.$emit("hideLoading");
                            }
                          });


                                            });

               
                      } else {
                        this.$root.$emit(
                          "showSnackBar",
                          "Ha ocurrido un error registrando el perfil APS",
                          "error"
                        );
                      }
                    });
                }
              });
             
                  this.disableConfirm=false 
          } else {
            this.newUser.password = this.newUser.profile.identity;
            this.$store.dispatch("registerUser", this.newUser).then(res => {
              if (res.data.code == 400) {
                this.$root.$emit(
                  "showSnackBar",
                  "Este usuario ya se ha registrado",
                  "error"
                );
                this.dialog = false;
                this.$root.$emit("hideLoading");
              } else if (res.data.code == 401) {
                this.$root.$emit(
                  "showSnackBar",
                  "La contraseña es incorrecta",
                  "error"
                );
                this.$root.$emit("hideLoading");
              } else {
                 
                  
                           let scopes = {
                                      userId: res.data.data.userId,
                                      scope: "aps_user aps_executive"
                                    };
                                  accountServices
                                            .updateScopesAccountIAM(scopes)
                                            .then(result => {
  this.$root.$emit("showSnackBar", "Registro Exitoso");
                    this.dialog = false;
                    EventBus.$emit("closeDialog");
                    this.$root.$emit("hideLoading");
                                            });

                  
                  
              }
            });
            
                  this.disableConfirm=false
          } 
              }else{
                
                  this.disableConfirm=false
                  this.$root.$emit(
                                  "showSnackBar",
                                  "Ha ocurrido un error creando el avatar",
                                  "error"
             );
              }
              })
        }
      });
    },
    saveDate(date) {
      this.$refs.menu.save(date);
    },
    saveDate1(date) {
      this.$refs.menu1.save(date);
    },
    saveDate2(date) {
      this.$refs.menu2.save(date);
    },
    removeEjecutive(item) {
      this.newUser.profile.executives.splice(
        this.newUser.profile.executives.indexOf(item),
        1
      );
      this.newUser.profile.executives = [...this.newUser.profile.executives];
    }
  }
};
</script>
